import React, { useState } from 'react';
import { useRemisiones } from '../../../hooks/useRemisiones';
import SKUSearcher from './SKUSearcher';
import RemisionesTable from './RemisionesTable';
import RemisionesMetrics from './RemisionesMetrics';
import RemisionesPagination from './RemisionesPagination';
import ProductosModal from './ProductosModal';
import PageLimitSelector from './PageLimitSelector';
import { Remision } from 'types/remisiones';

const RemisionesPorSKU: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [currentPage, setCurrentPage] = useState(1); // Usado en RemisionesPagination
  const [currentSKU, setCurrentSKU] = useState('');
  const [pageLimit, setPageLimit] = useState(30);
  const [selectedRemision, setSelectedRemision] = useState<Remision | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const {
    isLoading,
    error,
    data,
    searchRemisiones,
    clearData
  } = useRemisiones();

  const handleSearch = (sku: string) => {
    setCurrentSKU(sku);
    setCurrentPage(1);
    searchRemisiones(sku, 1, pageLimit);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    searchRemisiones(currentSKU, page, pageLimit);
  };

  const handleLimitChange = (newLimit: number) => {
    setPageLimit(newLimit);
    setCurrentPage(1);
    if (currentSKU) {
      searchRemisiones(currentSKU, 1, newLimit);
    }
  };

  const handleViewProducts = (remision: Remision) => {
    setSelectedRemision(remision);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedRemision(null);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="mb-6">
        <h3 className="text-xl font-semibold text-custom-blue mb-2">
          Remisiones por SKU
        </h3>
{/*         <p className="text-gray-600">
          Consulta las remisiones que contienen un producto específico
        </p> */}
      </div>

      <SKUSearcher 
        onSearch={handleSearch}
        isLoading={isLoading}
        onClear={clearData}
      />

      {data && (
        <>
          <RemisionesMetrics 
            totalRemisiones={data.totalRemisiones}
            productoId={data.productoId}
            isLoading={isLoading}
          />

          <RemisionesTable 
            remisiones={data.data}
            isLoading={isLoading}
            onViewProducts={handleViewProducts}
          />

          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <PageLimitSelector
              currentLimit={pageLimit}
              onLimitChange={handleLimitChange}
              isLoading={isLoading}
            />
            <RemisionesPagination
              pagination={data.pagination}
              onPageChange={handlePageChange}
              isLoading={isLoading}
            />
          </div>
        </>
      )}

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mt-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-red-800">
                Error al consultar remisiones
              </h3>
              <div className="mt-2 text-sm text-red-700">
                <p>{error}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Productos */}
      <ProductosModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        remision={selectedRemision}
      />
    </div>
  );
};

export default RemisionesPorSKU;
